import React from 'react';
import i18next from 'i18next';
import ShortEvent from '../ShortEvent/ShortEvent';
import { connect } from 'react-redux';
import { AnimatePresence, motion } from 'framer-motion';
import Delayed from '../../Delayed/Delayed';

class EventsList extends React.PureComponent {
  static defaultProps = {
    events: {},
  };

  render() {
    const {
      eventIds,
      pending,
      eventsType,
      activeGame,
      activeLeague,
      search,
    } = this.props;

    const variants = {
      initial: {
        opacity: 0,
      },
      visible: {
        opacity: 1,
        transition: { staggerChildren: 0.1, delayChildren: 0.5 },
      },
      hidden: { opacity: 0, transition: { duration: 0.3 } },
    };

    const item = {
      visible: { opacity: 1, x: 0 },
      initial: { opacity: 0, x: -200 },
      hidden: { opacity: 0, x: 0 },
    };

    if (pending) return null;

    if (!pending && !eventIds.length) {
      return (
        <div className="events-list__empty">
          {search
            ? i18next.t('events_list.empty')
            : i18next.t('events_list.no_active')}
        </div>
      );
    }

    const animated = eventIds.slice(0, 7);
    const restEvents = eventIds.slice(7);

    return (
      <React.Fragment>
        <AnimatePresence>
          <motion.div
            className="events-list"
            variants={variants}
            initial="initial"
            animate="visible"
            exit="hidden"
            key={eventsType + activeGame + activeLeague}
          >
            {animated.map((eventId) => (
              <motion.div variants={item} key={eventId}>
                <ShortEvent eventId={eventId} key={eventId} />
              </motion.div>
            ))}
          </motion.div>
        </AnimatePresence>
        <Delayed
          waitBeforeShow={2000}
          key={eventsType + activeGame + activeLeague}
        >
          {restEvents.map((eventId) => (
            <ShortEvent eventId={eventId} key={eventId} />
          ))}
        </Delayed>
      </React.Fragment>
    );
  }
}

export default connect((state, ownProps) => {
  const activeGame = state.events.filters.game;
  const activeLeague = state.events.filters.league;
  const search = state.events.filters.search;

  const eventsType = !search ? ownProps.eventsType : 'all';

  let allIds;
  if (eventsType === 'all') {
    allIds = [
      ...Object.keys(state.events['live']),
      ...Object.keys(state.events['prematch']),
    ];
  } else {
    allIds = Object.keys(state.events[eventsType]);
  }

  allIds = Array.from(new Set(allIds));

  const getEvent = (eventId) =>
    state.events['prematch'][eventId] || state.events['live'][eventId];

  const eventIds = allIds
    .filter((eventId) => {
      const event = getEvent(eventId);

      const eventName = [event['name_ht'], event['name_at']].join(' - ');

      if (search) {
        if (!eventName.toLowerCase().includes(search.toLowerCase()))
          return false;
      } else {
        if (activeGame && event['game'] !== activeGame) return false;
        if (activeLeague && event['ch_name'] !== activeLeague) return false;
      }
      if (getEvent(eventId).removed) return false;
      return true;
    })
    .sort((a, b) => {
      const keyA = new Date(getEvent(a)['date_start']);
      const keyB = new Date(getEvent(b)['date_start']);

      if (keyA < keyB) return -1;
      if (keyA > keyB) return 1;
      return 0;
    });

  return {
    eventIds,
    activeGame,
    activeLeague,
    search,
  };
}, {})(EventsList);



// WEBPACK FOOTER //
// ./app/components/EsportsGame/EventsList/EventsList.jsx